import React, { useState } from "react";
import { FiStar, FiBox, FiLayers, FiTarget, FiUser, FiGlobe, FiCheckCircle, FiArrowUpRight } from "react-icons/fi";
import { motion } from "framer-motion";

const cards = [
  {
    icon: <FiStar size={36} />,
    title: "Public Health Engineering",
    short: "Design and Drawings as per by laws, National Building Code, SP-35 & relevant code.",
    details: [
      "Conceptual / P & I Drawing Showing location of all Plumbing Utilities viz. STP, UGWT, OHT, OWC.",
      "Sewerage Layout.",
      "Storm Water Layout",
      "Toilet Layout",
      "Underground and Overhead Tank Layout along with sleeve details",
      "Terrace Rain Water Layout",
      "Hydro pneumatic System Details",
      "Rising Main Layout",
      "Rain Water Harvesting. Tender along with Technical Specifications"
    ],
  },
  {
    icon: <FiBox size={36} />,
    title: "Electrical System",
    short: "Complete design, tendering, contract negotiation, generator selection, automation, and technical discussions for electrical systems.",
    details: [
      "Complete design of internal & external installation, working of power load as per user’s requirements. Preparation of detailed budget",
      "Design of sizes of cables, transformer, HV/LV panels etc.",
      "Co-ordination with Architect / Landscape consultants as well with your office",
      "Preparation of Tenders /call RFQ’s, finalization of contracts and negotiation with the contractors / suppliers, to control investment in electrical works as per budget /requirements.",
      "Generator selection, testing & preparation of various auto change-over schemes.",
      "Design of building automation system, LAN / Wi-Fi connectivity on internet.",
      "Consulting in improvement of power factor of bulk consumers and reduction in harmonics. Periodic site inspections & quality check on workmanship of contractor.",
      "Assisting in purchasing better quality material at economical rates.",
      "Space planning for economic design for layout of transformer, energy metering panel / boxes etc.",
      "Check R.A. / Final Bill of electrical contractors and justifying the same with respect to work done.",
      "Ensuring the completion of work for safety and No Compliant from end user.",
      "Issue of Blue Prints to contractors, architects/Electrical Inspector, Site Engineers, State Electricity Board and finally to users/property managers.",
      "Assisting Electrical contractors in technical discussion with local electricity boards for power load sanction/ approvals.",
      "Testing of installations done by electrical contractor"
    ],
  },
  {
    icon: <FiLayers size={36} />,
    title: "Fire Fighting",
    short: "Includes hydrant layout, fire alarm, sprinkler, tank layout, and technical specifications for fire fighting systems.",
    details: [
      "This Includes Design and Drawing of all following systems as per PMC by laws, National Building Code, TAC Rules and relevant codes.",
      "Court Yard Hydrant Layout",
      "Fire Alarm System.",
      "Shaft Details",
      "Fire Alarm Layout.",
      "Sprinkler Layout.",
      "Underground Tank Layout.",
      "Tender along with Technical Specifications."
    ],
  },
  {
    icon: <FiTarget size={36} />,
    title: "Industrial Piping System",
    short: "Covers cooling water, compressed air, LDO, LPG piping systems, and more for industrial needs.",
    details: [
      "This Includes Design and Drawing of all following systems as per PMC by laws, National Building Code, TAC Rules and relevant codes.",
      "Cooling Water Systems.",
      "Compressed Air Piping System.",
      "LDO Piping System.",
      "LPG Piping System."
    ],
  },
  {
    icon: <FiUser size={36} />,
    title: "Building Automation System",
    short: "This Includes Design and Drawing of all following systems as per relevant codes.",
    details: [
      "This Includes Design and Drawing of all following systems as per relevant codes.",
      "Preparation of I/O Summary"
    ],
  },
  {
    icon: <FiGlobe size={36} />,
    title: "Low Voltage System",
    short: "This Includes Design all following systems",
    details: [
      "This Includes Design all following systems.",
      "CCTV Surveillance System",
      "Access Control System",
      "Computer Networking",
      "Intrusion / Security System",
      "PA System"
    ],
  },
  {
    icon: <FiCheckCircle size={36} />,
    title: "Working Segments",
    short: "School & Institutional Project, Residential, Business Buildings, Commercial Buildings, Auditorium, Industrial & Automobile Sector, Hotels, Hospitals, Institutes",
    details: [
      "School & Institutional Project",
      "Residential",
      "Business Buildings (IT Park, Office Buildings)",
      "Commercial Buildings (Shopping Malls, Multiplex etc.)",
      "Auditorium",
      "Industrial & Automobile Sector",
      "Hotels",
      "Hospitals",
      "Institutes"
    ],
  },
];

// Animation variants for cards
const cardVariants = {
  left: {
    hidden: { x: -120, opacity: 0 },
    visible: (i) => ({
      x: 0,
      opacity: 1,
      transition: {
        x: { type: "spring", stiffness: 60, damping: 18 },
        opacity: { duration: 0.3 },
        delay: i * 0.18,
        duration: 0.8,
      },
    }),
  },
  right: {
    hidden: { x: 120, opacity: 0 },
    visible: (i) => ({
      x: 0,
      opacity: 1,
      transition: {
        x: { type: "spring", stiffness: 60, damping: 18 },
        opacity: { duration: 0.3 },
        delay: i * 0.18,
        duration: 0.8,
      },
    }),
  },
  up: {
    hidden: { y: 80, opacity: 0 },
    visible: (i) => ({
      y: 0,
      opacity: 1,
      transition: {
        y: { type: "spring", stiffness: 60, damping: 18 },
        opacity: { duration: 0.3 },
        delay: i * 0.18,
        duration: 0.8,
      },
    }),
  },
  down: {
    hidden: { y: -80, opacity: 0 },
    visible: (i) => ({
      y: 0,
      opacity: 1,
      transition: {
        y: { type: "spring", stiffness: 60, damping: 18 },
        opacity: { duration: 0.3 },
        delay: i * 0.18,
        duration: 0.8,
      },
    }),
  },
};

const directions = ["left", "right", "up", "down", "left", "right", "up"];

export default function ServicesCards({ onViewMore }) {
  const [modalIdx, setModalIdx] = useState(null);

  const handleOpenModal = (idx) => setModalIdx(idx);
  const handleCloseModal = () => setModalIdx(null);

  return (
    <>
      {/* Modal for details */}
      {modalIdx !== null && (
        <motion.div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          onClick={handleCloseModal}
        >
          <motion.div
            style={{
              background: "#222",
              color: "#fff",
              borderRadius: "16px",
              padding: 0,
              minWidth: "340px",
              maxWidth: "420px",
              width: "100%",
              boxShadow: "0 8px 40px 0 rgba(0,0,0,0.25), 0 0 48px 12px rgba(0,123,255,0.75)",
              textAlign: "center",
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              overflow: "hidden"
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Left envelope panel - reduced width */}
            <motion.div
              style={{ width: "10%", minWidth: 0, background: "#1a2733", display: "flex", alignItems: "center", justifyContent: "flex-end" }}
              initial={{ x: 0 }}
              animate={{ x: "-100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            />
            {/* Modal content slides in from left to right, with maxWidth for content */}
            <motion.div
              style={{
                flex: 1,
                minWidth: 0,
                padding: "40px 32px",
                maxWidth: 600,
                margin: "0 auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                background: "#222",
                overflowY: "auto",
                maxHeight: "80vh",
                scrollbarColor: "#26658C #181818",
                scrollbarWidth: "thin"
              }}
              initial={{ x: -120, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.35, ease: "easeOut" }}
            >
              {/* Custom scrollbar styles */}
              <style>{`
                .modal-scroll::-webkit-scrollbar {
                  width: 8px;
                  background: #181818;
                  border-radius: 8px;
                }
                .modal-scroll::-webkit-scrollbar-thumb {
                  background: linear-gradient(135deg, #26658C 0%, #0d2a3a 100%);
                  border-radius: 8px;
                }
                .modal-scroll {
                  scrollbar-color: #26658C #181818;
                  scrollbar-width: thin;
                }
              `}</style>
              <div className="modal-scroll" style={{ width: "100%" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>{cards[modalIdx].icon}</div>
                <h2 style={{ fontSize: 28, marginBottom: 18 }}>{cards[modalIdx].title}</h2>
                {Array.isArray(cards[modalIdx].details) ? (
                  <ul style={{ fontSize: 16, color: "#ccc", marginBottom: 24, textAlign: "left", paddingLeft: 0, listStyle: "disc inside" }}>
                    {cards[modalIdx].details.map((item, i) => (
                      <li key={i} style={{ marginBottom: 8 }}>{item}</li>
                    ))}
                  </ul>
                ) : (
                  <div style={{ fontSize: 16, color: "#ccc", marginBottom: 24 }}>{cards[modalIdx].details}</div>
                )}
                <button
                  style={{
                    background: "#fff",
                    color: "#222",
                    border: "none",
                    borderRadius: "6px",
                    padding: "6px 18px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: 500,
                    marginRight: "12px"
                  }}
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </motion.div>
            {/* Right envelope panel - reduced width */}
            <motion.div
              style={{ width: "10%", minWidth: 0, background: "#1a2733", display: "flex", alignItems: "center", justifyContent: "flex-start" }}
              initial={{ x: 0 }}
              animate={{ x: "100%" }}
              transition={{ duration: 0.5, delay: 0.7, ease: "easeInOut" }}
            />
          </motion.div>
        </motion.div>
      )}
      <div className="mt-12 mb-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 justify-center place-items-center mx-auto max-w-5xl text-white">
        {cards.map((card, idx) => {
          const dir = directions[idx % directions.length];
          return (
            <motion.div
              key={idx}
              className="group relative overflow-hidden rounded-xl w-80 h-96 bg-[#181818] shadow-lg text-white"
              custom={idx}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={cardVariants[dir]}
            >
              {/* Centered icon and title */}
              <div className="flex flex-col items-center justify-center w-full h-full transition-opacity duration-500 group-hover:opacity-0 text-white">
                <div className="mb-4">{card.icon}</div>
                <span className="text-2xl md:text-3xl font-extrabold text-center w-full break-words px-4">
                  {card.title}
                </span>
              </div>
              {/* Overlay on hover */}
              <div className="absolute bottom-0 left-0 flex h-0 w-full flex-col items-center justify-center overflow-hidden rounded-xl bg-gradient-to-t from-[#26658C] to-black/60 px-8 text-center text-base transition-all duration-500 group-hover:h-full text-white">
                <h3 className="mb-3 text-lg font-bold">{card.title}</h3>
                <p className="mb-4 text-sm">{card.short}</p>
                <button
                  className="mt-2 flex h-12 w-12 items-center justify-center rounded-full bg-white text-[#26658C] shadow-lg hover:bg-[#26658C] hover:text-white transition-colors duration-300"
                  onClick={e => { e.stopPropagation(); handleOpenModal(idx); }}
                  aria-label="View Details"
                >
                  <FiArrowUpRight size={20} />
                </button>
              </div>
            </motion.div>
          );
        })}
      </div>
    </>
  );
};

